import * as React from 'react';
import { type AlertProps } from '@mui/material/Alert';
import {
  type CustomContentProps,
  SnackbarContent,
  useSnackbar,
} from 'notistack';
import { Toast } from '@/context/notification/toast.component';

declare module 'notistack' {
  interface VariantOverrides {
    toast: {
      title?: React.ReactNode | string;
      type: AlertProps['severity'];
    };
  }
}

interface ToastExtraProps {
  title?: React.ReactNode | string;
  type: AlertProps['severity'];
}

export interface NotistackToastProps
  extends ToastExtraProps, CustomContentProps {}

export const NotistackToast = React.forwardRef<
  HTMLDivElement,
  NotistackToastProps
>((props, ref) => {
  const { closeSnackbar } = useSnackbar();

  const { id, message, style, title, type } = props;

  return (
    <SnackbarContent
      data-toast-id={`toast-${id}`}
      data-toast-type={`toast-${type}`}
      data-testid={id}
      ref={ref}
      role="alert"
      style={style}
    >
      <Toast
        content={message}
        onClose={() => closeSnackbar(id)}
        title={title}
        type={type}
      />
    </SnackbarContent>
  );
});
